import { createClient } from '@supabase/supabase-js';
import type { Database } from './adatbazis.ts';

const url = import.meta.env.VITE_SUPABASE_URL;
const kulcs = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!url || !kulcs) throw new Error('Hiányzik a VITE_SUPABASE_URL vagy a VITE_SUPABASE_ANON_KEY.');

// A megerősítő linket mi váltjuk be (verifyOtp token_hash-sel), ezért az URL-ből nem olvasunk munkamenetet.
export const supabase = createClient<Database>(url, kulcs, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
});
